import { ActionIcon } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useNavigation } from '../contexts/NavigationContext';

export function BackButton() {
  const { goBack } = useNavigation();

  return (
    <ActionIcon variant="subtle" size="lg" onClick={goBack}>
      <IconArrowLeft size={20} />
    </ActionIcon>
  );
}

export default BackButton;
